// extracted by mini-css-extract-plugin
export var sbShowMain = "playButton-module--sb-show-main--bwusL";
export var playButton = "playButton-module--playButton--3VFLC";